import React, { useState, useRef, useEffect } from 'react';
import { createSanitizeHtml } from 'utility';
import { useNavigate } from 'react-router-dom';
import { Button, Grid, CircularProgress, Checkbox, Box } from '@mui/material';
import {
  PageContainer,
  FilterPod,
  TableComponents,
  SimpleDialog,
  ButtonLoading
} from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns, generateData } from './components/Columns';
import Services from '../services/Services';
import InitFilters from './constants/InitFiltering';
import { useStyles } from './style';
import MessageDg from './components'
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

/**
 * منوی تامین مالی - زیر منوی درخواست تامین مالی
 */
export default function FinancialRequests() {
  //-- STATES --//
  let tableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [filters, setFilters] = useState(InitFilters());
  const [isOpenDg, setIsOpenDg] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isloadingDg, setIsLoadingDg] = useState(false);
  const [dataAgrremnt, setDataAgreement] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('***');
  const [isOpenDgSuccess, setIsOpenDgSuccess] = useState(false);
  const [acceptRequest, setAcceptRequest] = useState(false);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  //--HOOKS--//
  const classes = useStyles();
  const history = useNavigate();

  /**
     * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
     */
  const actionsList =
    getDynamicObjectAction([
      'invoiceFinancingRequestPage',
    ]);
  useEffect(() => {
    //اگه کاربر دسترسی داشته باشد ، این سرویس کال میشود
    actionsList['invoiceFinancingRequestPage'] && getPhoneNumber();
  }, []);

  useEffect(() => {
    if (!isOpenDg) {
      setTimeout(() => {
        setSelectedRow(null);
        setAcceptRequest(false);
      }, 500);
    }
  }, [isOpenDg]);
  //--API REQUESTS--//
  /**
   * دریافت لیست دیتای جدول
   */
  const getList = async (query) => {

    try {
      setLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      let params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      //const res = await Services.requestLoanCreditFacilities(params);
      const res = await Services.getFinancingListService(params);
      let list = [];
      if (res?.result.length > 0) {

        list = generateData(res?.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count || 0,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };
  const onOpenRequesyFinancialDg = (row) => {
    setSelectedRow(row);
    setIsOpenDg(true);
    setIsLoadingDg(true);
  }

  /**
   * دکمه ثبت در دیالوگ درخواست اعتبار
   */
  const onAgreement = async () => {
    setLoadingBtn(true);
    Services.requestFinancingPost(selectedRow?.['chain-id']).then(res => {
      handleCloseDialog();
      setLoadingBtn(false);
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100)
      setIsOpenDgSuccess(true);
    }).catch(error => {

      setLoadingBtn(false);
    });
  }

  const handleCloseDialog = () => {
    setIsOpenDg(false);
    setTimeout(() => {
      setSelectedRow(null);
      setDataAgreement(null);
    }, 200);
  };
  const getPhoneNumber = () => {
    Services.getPhoneNumberUserLogin().then(res => {
      setPhoneNumber(res?.result);
    }).catch(error => {

    })

  }

  const boldFont = (str) => {
    if (!str) {
      return ' ـــــ ';
    } else {

      return `<span class="${classes.textBold}">${str}</span>`;
    }
  };
  const getTextContract = () => {
    return `این قرارداد با مشتری کانونی به نام ${boldFont(selectedRow?.['seller-name'])} بابت زنجیره به نام ${boldFont(selectedRow?.['name'])} می‌باشد. مبلغ نهایی اعتبار قابل تخصیص به هر خریدار پس از اعتبارسنجی توسط شعبه مشخص خواهد شد. نحوه باز پرداخت اعتبار به صورت ${boldFont(selectedRow?.['repayment-type'])}، نرخ کارمزد ${boldFont(selectedRow?.['interest-rate'])} درصد و وثیقه مورد نیاز جهت دریافت اعتبار ${boldFont(selectedRow?.['collaterals'])} می‌باشد.`
  }

  const hint = 'در این بخش میتوانید درخواست اعتبار خود را به ازای هر زنجیره تامین ثبت کنید. پس از اعتبارسنجی درخواست توسط بانک، امکان استفاده از اعتبار مورد نظر فراهم خواهد شد.';

  return (
    <PageContainer
      title='درخواست اعتبار '
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.FINANCIALSUPPLY_INVOICEFINANCING_REQUESTS}
      className={classes.root}
    >
      {
        actionsList['invoiceFinancingRequestPage'] &&
        <>

          <Grid item xs={12}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>

          <TableComponents
            data={getList}
            columns={columns(history, onOpenRequesyFinancialDg)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getList(ps)
            }}
          />
        </>
      }

      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={isOpenDg}
        title="درخواست اعتبار "
      >
        <Grid container alignItems="center" >
          <Grid>
            <Grid style={{ textAlign: 'justify', lineHeight: '1.75' }}>

              <div dangerouslySetInnerHTML={{ __html: createSanitizeHtml(getTextContract()) }}>

              </div>

            </Grid>

            <Grid style={{ marginRight: '-12px' }}>
              <Checkbox
                color="primary"
                onChange={(e) => {
                  if (e?.target?.checked) {
                    setAcceptRequest(true);
                  } else {
                    setAcceptRequest(false);
                  }
                }}
                icon={<CheckBoxIcon />}
                checkedIcon={<CheckBoxIconFill />}
              />
              در صورت تایید شرایط فوق، درخواست شما ثبت خواهد شد.
            </Grid>
            <Grid style={{ marginTop: '16px' }}>
              <Grid xl={12} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                <ButtonLoading
                  variant="contained"
                  color="primary"
                  loading={loadingBtn}
                  name="تایید و ارسال درخواست"
                  disabled={!acceptRequest || loadingBtn}
                  onClick={onAgreement}
                />

                <Button
                  style={{ margin: '0 4px' }}
                  variant="contained"
                  onClick={handleCloseDialog}>
                  انصراف
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SimpleDialog>
      <MessageDg
        isOpenDg={isOpenDgSuccess}
        setIsOpenDg={setIsOpenDgSuccess}
        title='ثبت درخواست اعتبار'
        phoneNumber={phoneNumber} />
    </PageContainer>
  );
}
